import Snackbar, { VARIANT } from './Snackbar'
export { VARIANT }
export default Snackbar
